import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js"

export default class extends Controller {
  static values = {
    newRecord: { type: Boolean, default: false }
  };

  connect() {
    const now = new Date();
    const roundedMinutes = Math.ceil(now.getMinutes() / 5) * 5;
    now.setMinutes(roundedMinutes, 0, 0);

    // Format date in local time, not UTC
    const formatLocalDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    flatpickr(this.element, {
      locale: Russian,
      enableTime: true,
      time_24hr: true,
      minuteIncrement: 5,
      dateFormat: "Y-m-d\\TH:i",
      minDate: "today",
      inline: true,
      defaultDate: this.newRecordValue ? formatLocalDate(now) : null,
    });

    this.element.style.display = "none";
  }
}
